import React, { useEffect, FC } from "react";
import * as lottie from "lottie-web";

interface Props {
  animationData: any;
  speed?: number;
  loop?: boolean;
  autoplay?: boolean;
  startIndex?: number;
  onComplete?: () => void;
}

const Loader: FC<Props> = (props: Props) => {
  const {
    animationData,
    speed,
    loop,
    autoplay,
    startIndex,
    onComplete,
  } = props;

  let loaderWrapper: any = null;

  const assignRef = (image: any) => {
    loaderWrapper = image;
  };

  useEffect(() => {
    const animData = {
      wrapper: loaderWrapper,
      animType: "svg",
      loop: typeof loop !== "undefined" ? loop : true,
      prerender: true,
      autoplay: typeof autoplay !== "undefined" ? autoplay : true,
      animationData,
    };
    // @ts-ignore
    const anim = lottie.loadAnimation(animData);
    anim.addEventListener("complete", onComplete);
    anim.setSpeed(speed);

    anim.goToAndPlay(startIndex);

    return function cleanup() {
      anim.destroy();
    };
  }, [
    animationData,
    autoplay,
    loaderWrapper,
    loop,
    onComplete,
    speed,
    startIndex,
  ]);

  return <div ref={assignRef} id="loader" />;
};

Loader.defaultProps = {
  speed: 1,
  loop: undefined,
  autoplay: undefined,
  startIndex: 0,
  onComplete: () => {},
};

export default Loader;
